export default "__VITE_ASSET__a75a81f1__"